import React, { useState } from "react";
import { Table, Button, Upload, Input, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import axios from "axios";
import dataService from "../networks/api/service/dataService";
import PrimaryButton from "./TableComponent/ButtonComponent/Buttons";
import colors from "../assets/styles/colour";

function DynamicExcelUpload({ getExcelData }) {
  const [uploadedData, setUploadedData] = useState([]);
  const [columns, setColumns] = useState([]);

  const handleEditCell = (value, rowIndex, columnKey) => {
    setUploadedData((prevData) =>
      prevData.map((row, idx) =>
        idx === rowIndex ? { ...row, [columnKey]: value } : row
      )
    );
  };

  const generateColumns = (headers) => {
    return headers.map((header) => ({
      title: (
        <span style={{ fontWeight: 600,
          color: "#103d29",
          textAlign: "center",
          display: "block",
          whiteSpace: "nowrap", // ✅ Wrap long text
          wordWrap: "break-word",  }}>
          {header}
        </span>
      ),
      dataIndex: header,
      key: header,
      width: 250, // ✅ Increase column width
      align: "center",
      background:"red",
      render: (text, record, index) => (
        <Input
          value={record[header]}
          onChange={(e) => handleEditCell(e.target.value, index, header)}
          style={{
            width: "100%",
            background: "transparent",
            color: "#0f2944",
            border: "none",
            outline: "none",
            padding: "6px",
            fontSize: "11px",
            whiteSpace:"wrap"
          }}
        />
      ),
    }));
  };

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const parsedData = XLSX.utils.sheet_to_json(sheet, { defval: "" });
  
      // ✅ Convert Excel date serial numbers to readable dates
      const formattedData = parsedData.map((row, index) => {
        const updatedRow = { ...row, key: index };
  
        Object.keys(updatedRow).forEach((key) => {
          if (typeof updatedRow[key] === "number" && updatedRow[key] > 40000) {
            // Excel serial number detection (dates usually > 40000)
            const excelDate = XLSX.SSF.parse_date_code(updatedRow[key]);
            if (excelDate) {
              updatedRow[key] = `${excelDate.y}-${String(excelDate.m).padStart(2, "0")}-${String(excelDate.d).padStart(2, "0")}`;
            }
          }
        });
  
        return updatedRow;
      });
  
      setColumns(generateColumns(Object.keys(formattedData[0] || {})));
      setUploadedData(formattedData);
    };
    reader.readAsArrayBuffer(file);
    return false;
  };

  const saveAllUploadedData = async () => {
    const worksheet = XLSX.utils.json_to_sheet(uploadedData);
    const csvData = XLSX.utils.sheet_to_csv(worksheet); 
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Edited Data");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([csvData], { type: "text/csv" });
    // const blob = new Blob([excelBuffer], {
    //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    // });
    const formData = new FormData();
    formData.append("file", blob, "EditedData.csv");
  
    console.log("Uploading file...", formData);
  
    try {
      await getExcelData(formData); // ✅ Wait for the upload to complete
  
      // ✅ Clear UI after upload
      setUploadedData([]);
      setColumns([]);
      message.success("Events uploaded successfully!");
    } catch (error) {
      message.error("Failed to upload data.");
      console.error("Upload error:", error);
    }
  };

  const uploadBulkData = async (formData) => {
    const res = await dataService.uploadBulkConstituency(formData);
  };

  const cancelUpload = () => {
    setUploadedData([]);
    setColumns([]);
  };

  return (
    <div>
      <Upload
        beforeUpload={handleFileUpload}
        accept=".xlsx, .xls"
        showUploadList={false}
      >
        <Button icon={<UploadOutlined />} style={{ background: colors.buttoSecondary, color: "#fff" }}>Select Excel File</Button>
      </Upload>

      {uploadedData.length > 0 && (
       <div
       style={{
        marginTop: 20,
        background: "rgba(40, 60, 172, 0.15)",
        backdropFilter: "blur(10px)",
        borderRadius: "10px",
        padding: "15px",
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
      }}
     >
       <h3 style={{ color: colors.primary , fontSize: "14px", marginBottom: "10px" }}>📂 Uploaded Data (Editable)</h3>
 
       <Table
         dataSource={uploadedData}
         columns={columns}
         rowKey="key"
         pagination={true}
         bordered={false} 
         size="small"
         style={{
          overflowX: "auto",
              background: "rgba(91, 106, 205, 0.2)",
              borderRadius: "8px",
         }}
         scroll={{ x: 800 }}
         
       />
 
       <div style={{ marginTop: 10, display: "flex", gap: "10px" }}>
         <Button type="primary" style={{ background: colors.button, borderRadius: "6px", fontSize: "11px" }} onClick={saveAllUploadedData}>
           Upload Data
         </Button>
         <Button type="primary"  style={{ borderRadius: "6px", fontSize: "11px" , color: colors.background, background: colors.primary}} onClick={cancelUpload}>
           Cancel
         </Button>
       </div>
     </div>
      )}
    </div>
  );
}

export default DynamicExcelUpload;
